import { extractMessagesService } from '../../../services/boteria/extractMessages';

export function ExtractMessages (dashboardTokenBoteria, botId, day, tokenPartners) {    
	return {
		type: 'EXTRACT_MESSAGES',
		payload: extractMessagesService(dashboardTokenBoteria, botId, day, tokenPartners)
	}
}